import bem from 'utils/bem';
import { Background, ImageBackgroundType } from './types';

export const block = bem('asset-tile');

export function isImageBackground(bg: Background): bg is ImageBackgroundType {
  return bg.type === 'image';
}
